import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchClaimSettlements = createProvider(api.fetchClaimSettlements).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Fetch claim settlements aborted');
  } else {
    console.error('Fetch claim settlements was failed:', error);
  }
  throw error;
});
